<p-table stripedRows
  #dt
  ariaLabel="Tabella pubblicazioni"
  styleClass="p-table-albi-pubblicazioni-list"
  dataKey="id"
  [value]="pubblicazioni"
  [columns]="cols"
  [sortField]="initialSortField"
  [sortOrder]="-1"
  [defaultSortOrder]="-1"
  [reorderableColumns]="false"
  [rows]="rowsNumber"
  scrollHeight="flex"
  [scrollable]="true"
  [virtualScroll]="true"
  [virtualScrollDelay]="150"
  [virtualScrollItemSize]="85"
  [lazy]="true"
  (onLazyLoad)="onLazyLoad($any($event))"
  [loading]="loading"
  [ngClass]="{ 'table-zero-rows': totalRecords === 0 }"
  tableStyleClass="pubblicazionilist-table-body"
  selectionMode="single"
  [(selection)]="selectedPubblicazione"
  (onRowSelect)="onRowSelected(true, $event.data)"
  (onRowUnselect)="onRowSelected(false, $event.data)"
  [exportFilename]="exportCsvName"
>
  --------------------------------
  <!-- [totalRecords]="totalRecords" -->
  <!-- [lazyLoadOnInit]="true" -->

  <ng-template
    pTemplate="caption"
    *ngIf="showEsitiCaption"
  >
    <p-selectButton
      class="esiti-caption-row"
      [options]="selectCodiceEsitiItems"
      [(ngModel)]="selectedCodiceEsiti"
      optionLabel="nome"
      (onOptionClick)="myDatatableReset(); onSelectButtonItemSelection($event)"
    >
    </p-selectButton>
  </ng-template>
  <!-- HEADER & ORDINAMENTO -->
  <ng-template
    pTemplate="header"
    let-columns
  >
    <tr class="header-row">
      <th
        *ngFor="let col of columns"
        [ngSwitch]="col.field"
        [ngClass]="col.headerClass"
        [pSortableColumn]="col.sortField"
      >
        <span
          class="header-box"
          [pTooltip]="col.sortField ? null : 'Colonna ' + col.header + ' non ordinabile'"
          [attr.aria-label]="col.label"
        >
          {{ col.header }}
          <p-sortIcon
            *ngIf="col.sortField"
            [field]="col.sortField"
          >
          </p-sortIcon>
        </span>
      </th>
    </tr>
    <!-- FILTRI -->
    <tr class="filter-row">
      <th
        *ngFor="let col of columns"
        [ngSwitch]="col.field"
        [ngClass]="col.filterClass"
      >
        <!-- Initial fields of Albo -->
        <div
          *ngSwitchCase="'datiPubblicazione'"
          class="search-wrapper"
        >
          <p-columnFilter
            #colfilterdatiPubblicazione
            type="numeric"
            [field]="col.filterField"
            [matchMode]="col.filterMatchMode"
            [showMenu]="false"
            [useGrouping]="false"
            placeholder="Filtra numero"
            pTooltip="Inserire solo numeri"
            [showClearButton]="false"
          >
          </p-columnFilter>
          <button
            *ngIf="colfilterdatiPubblicazione.hasFilter"
            class="material-icons close-icon"
            type="reset"
            (click)="colfilterdatiPubblicazione.clearFilter()"
          >
            close
          </button>
        </div>
        <div
          *ngSwitchCase="'datiRegistro'"
          class="search-wrapper"
        >
          <p-columnFilter
            #colfilterRegistro2
            field="tipiDocumentiList.codiceRegistro"
            matchMode="in"
            [showMenu]="false"
            [showClearButton]="false"
          >
            <ng-template
              pTemplate="filter"
              let-value
              let-filter="filterCallback"
            >
              <p-select
                #dropdownRegistro2
                [options]="registroFiltrabili2"
                [(ngModel)]="selectedRegistroFiltrabili2.value"
                optionValue="value"
                optionLabel="nome"
                [showClear]="true"
                (onChange)="filter($event.value)"
                appendTo="body"
                placeholder="Scegli registro"
              >
              </p-select>
            </ng-template>
          </p-columnFilter>
          <p-columnFilter
            #colfilterDatiRegistro
            type="numeric"
            [field]="col.filterField"
            [matchMode]="col.filterMatchMode"
            [showMenu]="false"
            [useGrouping]="false"
            placeholder="Filtra numero"
            pTooltip="Inserire solo numeri"
            [showClearButton]="false"
          >
          </p-columnFilter>
          <button
            *ngIf="colfilterDatiRegistro.hasFilter"
            class="material-icons close-icon"
            type="reset"
            (click)="colfilterDatiRegistro.clearFilter()"
          >
            close
          </button>
        </div>
        <div
          *ngSwitchCase="'oggetto'"
          class="search-wrapper"
        >
          <p-columnFilter
            #colfilterOggetto
            type="text"
            [field]="col.filterField"
            [matchMode]="col.filterMatchMode"
            [showMenu]="false"
            [showClearButton]="false"
          >
            <ng-template
              pTemplate="filter"
              let-value
              let-filterMethod="filterCallback"
            >
              <input
                #inputOggetto
                type="text"
                pInputText
                [value]="value"
                placeholder="Filtra oggetto"
                (keydown.enter)="removeSort(); filterMethod(inputOggetto.value === '' ? null : inputOggetto.value)"
              />
            </ng-template>
          </p-columnFilter>
          <button
            *ngIf="colfilterOggetto.hasFilter"
            class="material-icons close-icon"
            type="reset"
            (click)="colfilterOggetto.clearFilter(); resetSort()"
          >
            close
          </button>
        </div>
        <div
          *ngSwitchCase="'cig'"
          class="search-wrapper"
        >
          <p-columnFilter
            #colfilterCig
            type="text"
            [field]="col.filterField"
            [matchMode]="col.filterMatchMode"
            [showMenu]="false"
            [showClearButton]="false"
          >
            <ng-template
              pTemplate="filter"
              let-value
              let-filterMethod="filterCallback"
            >
              <input
                #inputCig
                type="text"
                pInputText
                [value]="value"
                placeholder="Filtra CIG"
                (keydown.enter)="removeSort(); filterMethod(inputCig.value === '' ? null : inputCig.value)"
              />
            </ng-template>
          </p-columnFilter>
          <button
            *ngIf="colfilterCig.hasFilter"
            class="material-icons close-icon"
            type="reset"
            (click)="colfilterCig.clearFilter(); resetSort()"
          >
            close
          </button>
        </div>
        <div
          *ngSwitchCase="'cigAzienda'"
          class="search-wrapper"
        >
          <p-columnFilter
            #colfilterCigAzienda
            type="text"
            [field]="col.filterField"
            [matchMode]="col.filterMatchMode"
            [showMenu]="false"
            [showClearButton]="false"
          >
            <ng-template
              pTemplate="filter"
              let-value
              let-filterMethod="filterCallback"
            >
              <input
                #inputCigAzienda
                type="text"
                pInputText
                [value]="value"
                placeholder="Filtra CIG Azienda"
                (keydown.enter)="removeSort(); filterMethod(inputCigAzienda.value === '' ? null : inputCigAzienda.value)"
              />
            </ng-template>
          </p-columnFilter>
          <button
            *ngIf="colfilterCigAzienda.hasFilter"
            class="material-icons close-icon"
            type="reset"
            (click)="colfilterCigAzienda.clearFilter(); resetSort()"
          >
            close
          </button>
        </div>
        <div
          *ngSwitchCase="'linkBdncp'"
          class="search-wrapper"
        >
          <p-columnFilter
            #colfilterLinkBdncp
            type="text"
            [field]="col.filterField"
            [matchMode]="col.filterMatchMode"
            [showMenu]="false"
            [showClearButton]="false"
          >
            <ng-template
              pTemplate="filter"
              let-value
              let-filterMethod="filterCallback"
            >
              <input
                #inputLinkBdncp
                type="text"
                pInputText
                [value]="value"
                placeholder="Filtra Link Bdncp"
                (keydown.enter)="removeSort(); filterMethod(inputLinkBdncp.value === '' ? null : inputLinkBdncp.value)"
              />
            </ng-template>
          </p-columnFilter>
          <button
            *ngIf="colfilterLinkBdncp.hasFilter"
            class="material-icons close-icon"
            type="reset"
            (click)="colfilterLinkBdncp.clearFilter(); resetSort()"
          >
            close
          </button>
        </div>
        <div
          *ngSwitchCase="'linkIntercent'"
          class="search-wrapper"
        >
          <p-columnFilter
            #colfilterLinkIntercent
            type="text"
            [field]="col.filterField"
            [matchMode]="col.filterMatchMode"
            [showMenu]="false"
            [showClearButton]="false"
          >
            <ng-template
              pTemplate="filter"
              let-value
              let-filterMethod="filterCallback"
            >
              <input
                #inputLinkIntercent
                type="text"
                pInputText
                [value]="value"
                placeholder="Filtra Link Intercent"
                (keydown.enter)="removeSort(); filterMethod(inputLinkIntercent.value === '' ? null : inputLinkIntercent.value)"
              />
            </ng-template>
          </p-columnFilter>
          <button
            *ngIf="colfilterLinkIntercent.hasFilter"
            class="material-icons close-icon"
            type="reset"
            (click)="colfilterLinkIntercent.clearFilter(); resetSort()"
          >
            close
          </button>
        </div>
        <div
          *ngSwitchCase="'esecutivita'"
          class="search-wrapper"
        >
          <p-columnFilter
            #colFilterEsecutivita
            [field]="col.filterField"
            matchMode="in"
            [showMenu]="false"
            placeholder="Scegli filtro"
            [showClearButton]="false"
          >
            <ng-template
              pTemplate="filter"
              let-value
              let-filter="filterCallback"
            >
              <p-multiSelect
                [showHeader]="false"
                [ngModel]="value"
                [options]="esecutivitaFiltrabili"
                optionValue="value"
                optionLabel="nome"
                (onChange)="filter($event.value)"
                appendTo="body"
              >
                <ng-template
                  let-option
                  pTemplate="item"
                >
                  <div>
                    <span>{{ option.nome }}</span>
                  </div>
                </ng-template>
              </p-multiSelect>
            </ng-template>
          </p-columnFilter>
        </div>
        <div
          *ngSwitchCase="'dataEsecutivita'"
          class="search-wrapper"
        >
          <p-columnFilter
            #colfilterDataEsecutivita
            [field]="col.filterField"
            type="date"
            matchMode="is"
            [showMenu]="false"
            [showClearButton]="false"
          >
            <ng-template
              pTemplate="filter"
              let-value
              let-filter="filterCallback"
            >
              <p-datepicker
                #calendar
                inputId="calendar"
                [ngModel]="value"
                [yearNavigator]="true"
                [monthNavigator]="true"
                yearRange="2000:2030"
                [minDate]="dataMinima"
                [maxDate]="dataMassima"
                dataType="date"
                dateFormat="dd/mm/yy"
                [showIcon]="false"
                [showButtonBar]="false"
                selectionMode="range"
                [readonlyInput]="true"
                placeholder="Scegli data"
                appendTo="body"
              >
                <ng-template
                  pTemplate="footer"
                  class="calendar-filter-footer-button"
                >
                  <div class="calendar-filter-footer-button-container">
                    <p-button (click)="handleCalendarButtonEvent(calendar, 'doFilter', $event, filter)">Conferma </p-button>
                    <p-button (click)="handleCalendarButtonEvent(calendar, 'setToday', $event, filter)">Oggi </p-button>
                    <p-button (click)="handleCalendarButtonEvent(calendar, 'clear', $event, filter)">Svuota </p-button>
                  </div>
                </ng-template>
              </p-datepicker>
            </ng-template>
          </p-columnFilter>
        </div>
        <div
          *ngSwitchCase="'dataAdozione'"
          class="search-wrapper"
        >
          <p-columnFilter
            #colfilterDataAdozione
            [field]="col.filterField"
            type="date"
            matchMode="is"
            [showMenu]="false"
            placeholder="Scegli data"
            [showClearButton]="false"
          >
            <ng-template
              pTemplate="filter"
              let-value
              let-filter="filterCallback"
            >
              <p-datepicker
                #calendarAdozione
                inputId="calendar"
                [ngModel]="value"
                [yearNavigator]="true"
                [monthNavigator]="true"
                yearRange="2000:2030"
                [minDate]="dataMinima"
                [maxDate]="dataMassima"
                dataType="date"
                dateFormat="dd/mm/yy"
                [showIcon]="false"
                [showButtonBar]="false"
                selectionMode="range"
                [readonlyInput]="true"
                placeholder="Scegli data"
                appendTo="body"
              >
                <ng-template
                  pTemplate="footer"
                  class="calendar-filter-footer-button"
                >
                  <div class="calendar-filter-footer-button-container">
                    <p-button (click)="handleCalendarButtonEvent(calendarAdozione, 'doFilter', $event, filter)"
                      >Conferma
                    </p-button>
                    <p-button (click)="handleCalendarButtonEvent(calendarAdozione, 'setToday', $event, filter)">Oggi </p-button>
                    <p-button (click)="handleCalendarButtonEvent(calendarAdozione, 'clear', $event, filter)">Svuota </p-button>
                  </div>
                </ng-template>
              </p-datepicker>
            </ng-template>
          </p-columnFilter>
        </div>
        <div
          *ngSwitchCase="'articolazione'"
          class="search-wrapper"
        >
          <p-columnFilter
            #colfilterArticolazione
            [field]="col.filterField"
            [matchMode]="col.filterMatchMode"
            [showMenu]="false"
            [useGrouping]="false"
            placeholder="Filtra articolazione"
            [showClearButton]="false"
          >
          </p-columnFilter>
          <button
            *ngIf="colfilterArticolazione.hasFilter"
            class="material-icons close-icon"
            type="reset"
            (click)="colfilterArticolazione.clearFilter()"
          >
            close
          </button>
        </div>
        <div
          *ngSwitchCase="'dataInizioPubblicazione'"
          class="search-wrapper"
        >
          <p-columnFilter
            #colfilterDataInizioPubblicazione
            [field]="col.filterField"
            type="date"
            matchMode="is"
            [showMenu]="false"
            [showClearButton]="false"
          >
            <ng-template
              pTemplate="filter"
              let-value
              let-filter="filterCallback"
            >
              <p-datepicker
                #calendarInizioPubblicazione
                inputId="calendarInizio"
                [ngModel]="value"
                [yearNavigator]="true"
                [monthNavigator]="true"
                yearRange="2000:2030"
                [minDate]="dataMinima"
                [maxDate]="dataMassima"
                dataType="date"
                dateFormat="dd/mm/yy"
                [showIcon]="false"
                [showButtonBar]="false"
                selectionMode="range"
                [readonlyInput]="true"
                placeholder="Scegli data"
                appendTo="body"
              >
                <ng-template
                  pTemplate="footer"
                  class="calendar-filter-footer-button"
                >
                  <div class="calendar-filter-footer-button-container">
                    <p-button (click)="handleCalendarButtonEvent(calendarInizioPubblicazione, 'doFilter', $event, filter)">
                      Conferma
                    </p-button>
                    <p-button (click)="handleCalendarButtonEvent(calendarInizioPubblicazione, 'setToday', $event, filter)"
                      >Oggi
                    </p-button>
                    <p-button (click)="handleCalendarButtonEvent(calendarInizioPubblicazione, 'clear', $event, filter)">
                      Svuota
                    </p-button>
                  </div>
                </ng-template>
              </p-datepicker>
            </ng-template>
          </p-columnFilter>
        </div>
        <div
          *ngSwitchCase="'dataFinePubblicazione'"
          class="search-wrapper"
        >
          <p-columnFilter
            #colfilterDataFinePubblicazione
            [field]="col.filterField"
            type="date"
            matchMode="is"
            [showMenu]="false"
            [showClearButton]="false"
          >
            <ng-template
              pTemplate="filter"
              let-value
              let-filter="filterCallback"
            >
              <p-datepicker
                #calendarFinePubblicazione
                inputId="calendarFine"
                [ngModel]="value"
                [yearNavigator]="true"
                [monthNavigator]="true"
                yearRange="2000:2030"
                [minDate]="dataMinima"
                [maxDate]="dataMassima"
                dataType="date"
                dateFormat="dd/mm/yy"
                [showIcon]="false"
                [showButtonBar]="false"
                selectionMode="range"
                [readonlyInput]="true"
                placeholder="Scegli data"
                appendTo="body"
              >
                <ng-template
                  pTemplate="footer"
                  class="calendar-filter-footer-button"
                >
                  <div class="calendar-filter-footer-button-container">
                    <p-button (click)="handleCalendarButtonEvent(calendarFinePubblicazione, 'doFilter', $event, filter)">
                      Conferma
                    </p-button>
                    <p-button (click)="handleCalendarButtonEvent(calendarFinePubblicazione, 'setToday', $event, filter)"
                      >Oggi
                    </p-button>
                    <p-button (click)="handleCalendarButtonEvent(calendarFinePubblicazione, 'clear', $event, filter)">
                      Svuota
                    </p-button>
                  </div>
                </ng-template>
              </p-datepicker>
            </ng-template>
          </p-columnFilter>
        </div>

        <!-- Extra fields For provvedimenti -->
        <div
          *ngSwitchCase="'dataInserimento'"
          class="search-wrapper"
        >
          <p-columnFilter
            #colfilterDataInserimento
            [field]="col.filterField"
            type="date"
            matchMode="is"
            [showMenu]="false"
            [showClearButton]="false"
          >
            <ng-template
              pTemplate="filter"
              let-value
              let-filter="filterCallback"
            >
              <p-datepicker
                #calendarInserimento
                inputId="calendar"
                [ngModel]="value"
                [yearNavigator]="true"
                [monthNavigator]="true"
                yearRange="2000:2030"
                [minDate]="dataMinima"
                [maxDate]="dataMassima"
                dataType="date"
                dateFormat="dd/mm/yy"
                [showIcon]="false"
                [showButtonBar]="false"
                selectionMode="range"
                [readonlyInput]="true"
                placeholder="Scegli data"
                appendTo="body"
              >
                <ng-template
                  pTemplate="footer"
                  class="calendar-filter-footer-button"
                >
                  <div class="calendar-filter-footer-button-container">
                    <p-button (click)="handleCalendarButtonEvent(calendarInserimento, 'doFilter', $event, filter)">
                      Conferma
                    </p-button>
                    <p-button (click)="handleCalendarButtonEvent(calendarInserimento, 'setToday', $event, filter)"
                      >Oggi
                    </p-button>
                    <p-button (click)="handleCalendarButtonEvent(calendarInserimento, 'clear', $event, filter)">Svuota </p-button>
                  </div>
                </ng-template>
              </p-datepicker>
            </ng-template>
          </p-columnFilter>
        </div>
        <div
          *ngSwitchCase="'tipoProvvedimento'"
          class="search-wrapper"
        >
          <p-columnFilter
            #colfilterTipoProvvedimento
            type="text"
            [field]="col.filterField"
            [matchMode]="col.filterMatchMode"
            [showMenu]="false"
            [showClearButton]="false"
          >
            <ng-template
              pTemplate="filter"
              let-value
              let-filterMethod="filterCallback"
            >
              <input
                #inputTipoProvvedimento
                type="text"
                pInputText
                [value]="value"
                placeholder="Filtra tipo provvedimento"
                (keydown.enter)="removeSort(); filterMethod(inputTipoProvvedimento.value)"
              />
            </ng-template>
          </p-columnFilter>
          <button
            *ngIf="colfilterTipoProvvedimento.hasFilter"
            class="material-icons close-icon"
            type="reset"
            (click)="colfilterTipoProvvedimento.clearFilter(); resetSort()"
          >
            close
          </button>
        </div>
        <div
          *ngSwitchCase="'dataUltimaModifica'"
          class="search-wrapper"
        >
          <p-columnFilter
            #colfilterDataUltimaModifica
            [field]="col.filterField"
            type="date"
            matchMode="is"
            [showMenu]="false"
            [showClearButton]="false"
          >
            <ng-template
              pTemplate="filter"
              let-value
              let-filter="filterCallback"
            >
              <p-datepicker
                #calendarUltimaModifica
                inputId="calendar"
                [ngModel]="value"
                [yearNavigator]="true"
                [monthNavigator]="true"
                yearRange="2000:2030"
                [minDate]="dataMinima"
                [maxDate]="dataMassima"
                dataType="date"
                dateFormat="dd/mm/yy"
                [showIcon]="false"
                [showButtonBar]="false"
                selectionMode="range"
                placeholder="Scegli data"
                [readonlyInput]="true"
                appendTo="body"
              >
                <ng-template
                  pTemplate="footer"
                  class="calendar-filter-footer-button"
                >
                  <div class="calendar-filter-footer-button-container">
                    <p-button (click)="handleCalendarButtonEvent(calendarUltimaModifica, 'doFilter', $event, filter)">
                      Conferma
                    </p-button>
                    <p-button (click)="handleCalendarButtonEvent(calendarUltimaModifica, 'setToday', $event, filter)">
                      Oggi
                    </p-button>
                    <p-button (click)="handleCalendarButtonEvent(calendarUltimaModifica, 'clear', $event, filter)">
                      Svuota
                    </p-button>
                  </div>
                </ng-template>
              </p-datepicker>
            </ng-template>
          </p-columnFilter>
        </div>

        <!-- Extra fields for Profile Committente -->
        <div
          *ngSwitchCase="'registro'"
          class="search-wrapper"
        >
          <p-columnFilter
            #colfilterRegistro
            [field]="col.filterField"
            matchMode="is"
            [showMenu]="false"
            [showClearButton]="false"
          >
            <ng-template
              pTemplate="filter"
              let-value
              let-filter="filterCallback"
            >
              <p-select
                #dropdownRegistro
                [options]="registroFiltrabili"
                [(ngModel)]="selectedRegistroFiltrabili.value"
                optionValue="value"
                optionLabel="nome"
                (onChange)="filter($event.value)"
                appendTo="body"
                placeholder="Scegli registro"
              >
              </p-select>
            </ng-template>
          </p-columnFilter>
        </div>
        <div
          *ngSwitchCase="'numeroRegistro'"
          class="search-wrapper"
        >
          <p-columnFilter
            #colfilterNumeroRegistro
            type="numeric"
            [field]="col.filterField"
            [matchMode]="col.filterMatchMode"
            [showMenu]="false"
            [useGrouping]="false"
            [showClearButton]="false"
            placeholder="Filtra numero"
            pTooltip="Inserire solo numeri"
          >
          </p-columnFilter>
          <button
            *ngIf="colfilterNumeroRegistro.hasFilter"
            class="material-icons close-icon"
            type="reset"
            (click)="colfilterNumeroRegistro.clearFilter()"
          >
            close
          </button>
        </div>
        <div
          *ngSwitchCase="'annoRegistro'"
          class="search-wrapper"
        >
          <p-columnFilter
            #colfilterAnnoRegistro
            type="numeric"
            [field]="col.filterField"
            [matchMode]="col.filterMatchMode"
            [showMenu]="false"
            [useGrouping]="false"
            [showClearButton]="false"
            placeholder="Filtra anno"
            pTooltip="Inserire solo numeri"
          >
          </p-columnFilter>
          <button
            *ngIf="colfilterAnnoRegistro.hasFilter"
            class="material-icons close-icon"
            type="reset"
            (click)="colfilterAnnoRegistro.clearFilter()"
          >
            close
          </button>
        </div>
        <div
          *ngSwitchCase="'dataRegistro'"
          class="search-wrapper"
        >
          <p-columnFilter
            #colfilterDataRegistrazione
            [field]="col.filterField"
            type="date"
            matchMode="is"
            [showMenu]="false"
            [showClearButton]="false"
          >
            <ng-template
              pTemplate="filter"
              let-value
              let-filter="filterCallback"
            >
              <p-datepicker
                #calendarRegistrazione
                inputId="calendarFine"
                [ngModel]="value"
                [yearNavigator]="true"
                [monthNavigator]="true"
                yearRange="2000:2030"
                [minDate]="dataMinima"
                [maxDate]="dataMassima"
                dataType="date"
                dateFormat="dd/mm/yy"
                [showIcon]="false"
                [showButtonBar]="false"
                selectionMode="range"
                [readonlyInput]="true"
                placeholder="Scegli data"
                appendTo="body"
              >
                <ng-template
                  pTemplate="footer"
                  class="calendar-filter-footer-button"
                >
                  <div class="calendar-filter-footer-button-container">
                    <p-button (click)="handleCalendarButtonEvent(calendarRegistrazione, 'doFilter', $event, filter)">
                      Conferma
                    </p-button>
                    <p-button (click)="handleCalendarButtonEvent(calendarRegistrazione, 'setToday', $event, filter)">
                      Oggi
                    </p-button>
                    <p-button (click)="handleCalendarButtonEvent(calendarRegistrazione, 'clear', $event, filter)"
                      >Svuota
                    </p-button>
                  </div>
                </ng-template>
              </p-datepicker>
            </ng-template>
          </p-columnFilter>
        </div>
        <div
          *ngSwitchCase="'dataPubblicazioneProfCom'"
          class="search-wrapper"
        >
          <p-columnFilter
            #colfilterDataPubblicazioneProfCom
            [field]="col.filterField"
            type="date"
            matchMode="is"
            [showMenu]="false"
            [showClearButton]="false"
          >
            <ng-template
              pTemplate="filter"
              let-value
              let-filter="filterCallback"
            >
              <p-datepicker
                #calendarPubblicazioneProfCom
                inputId="calendar"
                [ngModel]="value"
                [yearNavigator]="true"
                [monthNavigator]="true"
                yearRange="2000:2030"
                [minDate]="dataMinima"
                [maxDate]="dataMassima"
                dataType="date"
                dateFormat="dd/mm/yy"
                [showIcon]="false"
                [showButtonBar]="false"
                selectionMode="range"
                [readonlyInput]="true"
                placeholder="Scegli data"
                appendTo="body"
              >
                <ng-template
                  pTemplate="footer"
                  class="calendar-filter-footer-button"
                >
                  <div class="calendar-filter-footer-button-container">
                    <p-button (click)="handleCalendarButtonEvent(calendarPubblicazioneProfCom, 'doFilter', $event, filter)">
                      Conferma
                    </p-button>
                    <p-button (click)="handleCalendarButtonEvent(calendarPubblicazioneProfCom, 'setToday', $event, filter)"
                      >Oggi
                    </p-button>
                    <p-button (click)="handleCalendarButtonEvent(calendarPubblicazioneProfCom, 'clear', $event, filter)"
                      >Svuota
                    </p-button>
                  </div>
                </ng-template>
              </p-datepicker>
            </ng-template>
          </p-columnFilter>
        </div>

        <!-- Extra fields for Registro Accessi -->
        <div
          *ngSwitchCase="'tipoProcedimento'"
          class="search-wrapper"
        >
          <p-columnFilter
            #colfilterTipoProcedimento
            [field]="col.filterField"
            [matchMode]="col.filterMatchMode"
            [showMenu]="false"
            [useGrouping]="false"
            placeholder="Filtra tipo procedimento"
            [showClearButton]="false"
          >
          </p-columnFilter>
          <button
            *ngIf="colfilterTipoProcedimento.hasFilter"
            class="material-icons close-icon"
            type="reset"
            (click)="colfilterTipoProcedimento.clearFilter()"
          >
            close
          </button>
        </div>
        <div
          *ngSwitchCase="'articolazione2'"
          class="search-wrapper"
        >
          <p-columnFilter
            #colfilterArticolazione2
            [field]="col.filterField"
            [matchMode]="col.filterMatchMode"
            [showMenu]="false"
            [useGrouping]="false"
            placeholder="Filtra UO procedente"
            [showClearButton]="false"
          >
          </p-columnFilter>
          <button
            *ngIf="colfilterArticolazione2.hasFilter"
            class="material-icons close-icon"
            type="reset"
            (click)="colfilterArticolazione2.clearFilter()"
          >
            close
          </button>
        </div>
        <!-- Todo fix this -->
        <div
          *ngSwitchCase="'attoDiIniziativa'"
          class="search-wrapper"
        >
          <p-columnFilter
            #colfilterAttoDiIniziativa
            type="numeric"
            [field]="col.filterField"
            [matchMode]="col.filterMatchMode"
            [showMenu]="false"
            [useGrouping]="false"
            placeholder="Filtra numero"
            pTooltip="Inserire solo numeri"
            [showClearButton]="false"
          >
          </p-columnFilter>
          <button
            *ngIf="colfilterAttoDiIniziativa.hasFilter"
            class="material-icons close-icon"
            type="reset"
            (click)="colfilterAttoDiIniziativa.clearFilter()"
          >
            close
          </button>
        </div>
        <!-- Todo fix this -->
        <div
          *ngSwitchCase="'dataIniziativa'"
          class="search-wrapper"
        >
          <p-columnFilter
            #colfilterDataIniziativa
            [field]="col.filterField"
            type="date"
            matchMode="is"
            [showMenu]="false"
            [showClearButton]="false"
          >
            <ng-template
              pTemplate="filter"
              let-value
              let-filter="filterCallback"
            >
              <p-datepicker
                #calendarDataIniziativa
                inputId="calendarFine"
                [ngModel]="value"
                [yearNavigator]="true"
                [monthNavigator]="true"
                yearRange="2000:2030"
                [minDate]="dataMinima"
                [maxDate]="dataMassima"
                dataType="date"
                dateFormat="dd/mm/yy"
                [showIcon]="false"
                [showButtonBar]="false"
                selectionMode="range"
                [readonlyInput]="true"
                placeholder="Scegli data"
                appendTo="body"
              >
                <ng-template
                  pTemplate="footer"
                  class="calendar-filter-footer-button"
                >
                  <div class="calendar-filter-footer-button-container">
                    <p-button (click)="handleCalendarButtonEvent(calendarDataIniziativa, 'doFilter', $event, filter)">
                      Conferma
                    </p-button>
                    <p-button (click)="handleCalendarButtonEvent(calendarDataIniziativa, 'setToday', $event, filter)">
                      Oggi
                    </p-button>
                    <p-button (click)="handleCalendarButtonEvent(calendarDataIniziativa, 'clear', $event, filter)">
                      Svuota
                    </p-button>
                  </div>
                </ng-template>
              </p-datepicker>
            </ng-template>
          </p-columnFilter>
        </div>
        <div
          *ngSwitchCase="'controinteressati'"
          class="search-wrapper"
        >
          <p-columnFilter
            #colfiltercontrointeressati
            [field]="col.filterField"
            [matchMode]="col.filterMatchMode"
            [showMenu]="false"
            [showClearButton]="false"
            type="boolean"
          >
          </p-columnFilter>
        </div>
        <div
          *ngSwitchCase="'esito'"
          class="search-wrapper"
        >
          <p-columnFilter
            #colfilterEsito
            [field]="col.filterField"
            matchMode="in"
            [showMenu]="false"
            [showClearButton]="false"
          >
            <ng-template
              pTemplate="filter"
              let-value
              let-filter="filterCallback"
            >
              <p-multiSelect
                [showHeader]="false"
                [ngModel]="value"
                [options]="esitoFiltrabili"
                optionValue="value"
                optionLabel="nome"
                (onChange)="filter($event.value)"
                appendTo="body"
              >
                <ng-template
                  let-option
                  pTemplate="item"
                >
                  <div>
                    <span>{{ option.nome }}</span>
                  </div>
                </ng-template>
              </p-multiSelect>
            </ng-template>
          </p-columnFilter>
        </div>
        <!-- Todo fix this -->
        <div
          *ngSwitchCase="'provvedimentoFinale'"
          class="search-wrapper"
        >
          <p-columnFilter
            #colfilterProvvedimentoFinale
            type="numeric"
            [field]="col.filterField"
            [matchMode]="col.filterMatchMode"
            [showMenu]="false"
            [useGrouping]="false"
            pTooltip="Inserire solo numeri"
            placeholder="Filtra numero"
            [showClearButton]="false"
          >
          </p-columnFilter>
          <button
            *ngIf="colfilterProvvedimentoFinale.hasFilter"
            class="material-icons close-icon"
            type="reset"
            (click)="colfilterProvvedimentoFinale.clearFilter()"
          >
            close
          </button>
        </div>
        <!-- Todo fix this -->
        <div
          *ngSwitchCase="'dataChiusura'"
          class="search-wrapper"
        >
          <p-columnFilter
            #colfilterDataChiusura
            [field]="col.filterField"
            type="date"
            matchMode="is"
            [showMenu]="false"
            [showClearButton]="false"
          >
            <ng-template
              pTemplate="filter"
              let-value
              let-filter="filterCallback"
            >
              <p-datepicker
                #calendarDataChiusura
                inputId="calendarFine"
                [ngModel]="value"
                [yearNavigator]="true"
                [monthNavigator]="true"
                yearRange="2000:2030"
                [minDate]="dataMinima"
                [maxDate]="dataMassima"
                dataType="date"
                dateFormat="dd/mm/yy"
                [showIcon]="false"
                [showButtonBar]="false"
                selectionMode="range"
                [readonlyInput]="true"
                placeholder="Scegli data"
                appendTo="body"
              >
                <ng-template
                  pTemplate="footer"
                  class="calendar-filter-footer-button"
                >
                  <div class="calendar-filter-footer-button-container">
                    <p-button (click)="handleCalendarButtonEvent(calendarDataChiusura, 'doFilter', $event, filter)">
                      Conferma
                    </p-button>
                    <p-button (click)="handleCalendarButtonEvent(calendarDataChiusura, 'setToday', $event, filter)"
                      >Oggi
                    </p-button>
                    <p-button (click)="handleCalendarButtonEvent(calendarDataChiusura, 'clear', $event, filter)"
                      >Svuota
                    </p-button>
                  </div>
                </ng-template>
              </p-datepicker>
            </ng-template>
          </p-columnFilter>
        </div>
        <div
          *ngSwitchCase="'motivazione'"
          class="search-wrapper"
        >
          <p-columnFilter
            #colfilterMotivazione
            [field]="col.filterField"
            [matchMode]="col.filterMatchMode"
            [showMenu]="false"
            [useGrouping]="false"
            placeholder="Filtra motivazione"
            [showClearButton]="false"
          >
          </p-columnFilter>
          <button
            *ngIf="colfilterMotivazione.hasFilter"
            class="material-icons close-icon"
            type="reset"
            (click)="colfilterMotivazione.clearFilter()"
          >
            close
          </button>
        </div>
      </th>
    </tr>
  </ng-template>
  <!-- BODY -->
  <ng-template
    pTemplate="body"
    let-rowData
    let-columns="columns"
  >
    <tr
      class="row-height"
      [pSelectableRow]="rowData"
    >
      <td
        *ngFor="let col of columns"
        [ngSwitch]="col.field"
        [ngClass]="col.bodyClass"
      >
        <div *ngSwitchCase="'datiPubblicazione'">
          {{ rowData.datiPubblicazioneVisualizzazione }}
        </div>
        <div *ngSwitchCase="'datiRegistro'">
          {{ rowData.datiRegistroVisualizzazione }}
        </div>
        <div
          *ngSwitchCase="'oggetto'"
          class="oggetto-content"
          [pTooltip]="rowData.oggetto"
          [innerHTML]="rowData.oggetto"
          tooltipPosition="top"
        >
          {{ rowData.oggetto }}
        </div>
        <div
          *ngSwitchCase="'cig'"
          class="cig-content"
          [pTooltip]="rowData.pubblicazioneCommittente.cig"
          [innerHTML]="rowData.pubblicazioneCommittente.cig"
          tooltipPosition="top"
        >
          {{ rowData.pubblicazioneCommittente.cig }}
        </div>
        <div
          *ngSwitchCase="'cigAzienda'"
          class="cigAzienda-content"
          [pTooltip]="rowData.pubblicazioneCommittente.cigAzienda"
          [innerHTML]="rowData.pubblicazioneCommittente.cigAzienda"
          tooltipPosition="top"
        >
          {{ rowData.pubblicazioneCommittente.cigAzienda }}
        </div>
        <div
          *ngSwitchCase="'linkBdncp'"
          class="linkBdncp-content"
          [pTooltip]="rowData.pubblicazioneCommittente.linkBdncp"
          [innerHTML]="rowData.pubblicazioneCommittente.linkBdncp"
          tooltipPosition="top"
        >
          <a href="rowData.pubblicazioneCommittente.linkBdncp">{{ rowData.pubblicazioneCommittente.linkBdncp }}</a>
        </div>
        <div
          *ngSwitchCase="'linkIntercent'"
          class="linkIntercent-content"
          [pTooltip]="rowData.pubblicazioneCommittente.linkIntercent"
          [innerHTML]="rowData.pubblicazioneCommittente.linkIntercent"
          tooltipPosition="top"
        >
          <a href="rowData.pubblicazioneCommittente.linkIntercent">{{ rowData.pubblicazioneCommittente.linkIntercent }}</a>
        </div>
        <div *ngSwitchCase="'esecutivita'">
          {{ rowData.esecutivitaVisualizzazione }}
        </div>
        <div *ngSwitchCase="'dataEsecutivita'">
          {{
            rowData.tipiDocumentiList && rowData.tipiDocumentiList[0]
              ? (rowData.tipiDocumentiList[0].dataEsecutivita | date : "dd/MM/yyyy")
              : ""
          }}
        </div>
        <div *ngSwitchCase="'dataAdozione'">
          {{ rowData.dataAdozioneVisualizzazione | date : "dd/MM/yyyy" }}
        </div>
        <div
          *ngSwitchCase="'articolazione'"
          [pTooltip]="rowData.articolazione"
          class="articolazione-content"
          tooltipPosition="top"
        >
          {{ rowData.articolazione }}
        </div>
        <div *ngSwitchCase="'dataInizioPubblicazione'">
          {{ rowData.dataInizioPubblicazioneVisualizzazione | date : "dd/MM/yyyy" }}
        </div>
        <div *ngSwitchCase="'dataFinePubblicazione'">
          {{ rowData.dataFinePubblicazioneVisualizzazione | date : "dd/MM/yyyy" }}
        </div>
        <!-- Extra fields For provvedimenti -->
        <div *ngSwitchCase="'dataInserimento'">
          {{ rowData.dataInserimento | date : "dd/MM/yyyy" }}
        </div>
        <div
          *ngSwitchCase="'tipoProvvedimento'"
          class="scrollable"
          [pTooltip]="rowData.provvedimento.tipoProvvedimento"
        >
          {{ rowData.provvedimento.tipoProvvedimento }}
        </div>
        <div *ngSwitchCase="'dataUltimaModifica'">
          {{ rowData.dataUltimaModifica | date : "dd/MM/yyyy" }}
        </div>
        <!-- Extra fields for Profile Committente -->
        <div *ngSwitchCase="'registro'">
          {{ rowData.registroVisualizzazione }}
        </div>
        <div *ngSwitchCase="'codiceProfiloCommittente'">
          {{ rowData.codiceProfiloCommittenteVisualizzazione }}
        </div>
        <div *ngSwitchCase="'numeroRegistro'">
          {{ rowData.numeroRegistroVisualizzazione }}
        </div>
        <div *ngSwitchCase="'annoRegistro'">
          {{ rowData.annoRegistroVisualizzazione }}
        </div>
        <div *ngSwitchCase="'dataRegistro'">
          {{ rowData.dataRegistrazioneVisualizzazione | date : "dd/MM/yyyy" }}
        </div>
        <div *ngSwitchCase="'dataPubblicazioneProfCom'">
          {{ rowData.dataInserimento | date : "dd/MM/yyyy" }}
        </div>
        <!-- Extra fields for Registro Accessi-->
        <div *ngSwitchCase="'tipoProcedimento'">
          {{ rowData.registroAccessi.tipoProcedimento }}
        </div>
        <div
          *ngSwitchCase="'articolazione2'"
          class="articolazione2-content"
        >
          {{ rowData.articolazione }}
        </div>
        <div *ngSwitchCase="'attoDiIniziativa'">
          {{ rowData.attoDiIniziativaVisualizzazione }}
        </div>
        <div *ngSwitchCase="'dataIniziativa'">
          {{ rowData.dataIniziativaVisualizzazione | date : "dd/MM/yyyy" }}
        </div>
        <div
          *ngSwitchCase="'controinteressati'"
          class="justify-center"
        >
          <i
            class="pi"
            [ngClass]="{
              'true-icon pi-check': rowData.registroAccessi.controinteressati,
              'false-icon pi-times': !rowData.registroAccessi.controinteressati
            }"
          ></i>
        </div>
        <div *ngSwitchCase="'esito'">
          {{ rowData.registroAccessi.esito }}
        </div>
        <div *ngSwitchCase="'provvedimentoFinale'">
          {{ rowData.provvedimentoFinaleVisualizzazione }}
        </div>
        <div *ngSwitchCase="'dataChiusura'">
          {{ rowData.dataChiusuraVisualizzazione | date : "dd/MM/yyyy" }}
        </div>
        <div
          *ngSwitchCase="'motivazione'"
          [pTooltip]="rowData.registroAccessi.motivazione"
          class="motivazione-content"
          tooltipPosition="left"
        >
          {{ rowData.registroAccessi.motivazione }}
        </div>
      </td>
    </tr>
  </ng-template>
  <ng-template
    pTemplate="loadingbody"
    let-columns="columns"
  >
    <tr class="row-height">
      <td
        *ngFor="let col of columns"
        [ngClass]="col.bodyClass"
        class="loading-cell"
      >
        <div class="loading-text"></div>
      </td>
    </tr>
  </ng-template>
</p-table>
<p-toast key="pubblicazioniListToast"></p-toast>
<p-confirmDialog
  [baseZIndex]="10000"
  acceptLabel="Sì"
></p-confirmDialog>
<p-confirmPopup key="confirm-popup"></p-confirmPopup>
